import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AuthUser {
  email: string;
  sub: string;
  role: string;
  teamId?: string;
  companyId?: string;
  nurseId?: string;
  exp?: number;
  tokenType?: "access";
}

interface AuthState {
  token: string | null;
  refresh_token: string | null;
  user: AuthUser | null;
  setToken: (token: string | null, refreshToken: string | null) => void;
  clearToken: () => void;
}

export const parseJwt = (token: string): AuthUser | null => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((character) => `%${(`00${character.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(""),
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      refresh_token: null,
      user: null,
      setToken: (token: string | null, refreshToken: string | null) => {
        const user = token ? parseJwt(token) : null;
        set({ token, refresh_token: refreshToken, user });
      },
      clearToken: () => set({ token: null, refresh_token: null, user: null }),
    }),
    {
      name: "dutyon-auth-storage",
    },
  ),
);
